import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const  ifreaAnalyticsSettingSchema = yup.object().shape({
  ifrea_analytics_restaurant_id: yup.string().required('入力必須項目です'),
});
export const useRegisterIfreaAnalyticsSettingForm = () => {
  const { handleSubmit, register, formState: { errors, isSubmitting } } = useForm({resolver: yupResolver( ifreaAnalyticsSettingSchema),});
  return {
    handleSubmit,
    register,
    isSubmitting,
    errors,
  };
};